import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Checkbox,
  Input,
  Typography,
  Select,
} from "antd";
import useAxiosPost from "../../hooks/useAxiosPost";
import "./index.css";
import useMultiNotification from "../../hooks/useNotification";
import { useNavigate, useParams } from "react-router-dom";
interface SelectOptions {
  value: string;
  label: string;
}
const AssignPackageToUserComponent = () => {
  const { intPkClientID } = useParams();
  const navigate = useNavigate();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<AssignPackageToClientApiProp>(
    "packages/assignPackageToClient"
  );
  const { openNotification, contextHolder } = useMultiNotification();

  const [allTariffs, setAllPackages] = useState<any>([]);
  const [packageOptions, setAllPackageOptions] = useState<SelectOptions[]>([]);
  const [
    getPackagesApi,
    packagesApiResponse,
    packagesApiError,
    packagesApiLoading,
    packagesApiMessage,
    packagesApiApiErrorCount,
  ] = useAxiosPost<ResponseProp>("packages/getMyPackages");
  useEffect(() => {
    if (packagesApiResponse !== null) {
      // userType, email
      const responseData: any = packagesApiResponse.responseData;
      console.log({ responseData });
      setAllPackages(responseData || []);
      const res = responseData || [];
      setAllPackageOptions(
        res.map((item: any) => {
          return {
            label: item.packageName,
            value: item.intPkPackageID,
          };
        })
      );
    }
  }, [packagesApiResponse]);
  useEffect(() => {
    getPackagesApi({});
  }, []);

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const onFinish = (values: any) => {
    // Handle form submission, values.email will contain the entered email address
    console.log("Received values:", values);
    const { packageId } = values;

    const dataToSend = {
      intPkPackageID: Number(packageId),
      intPkClientID: Number(intPkClientID),
    };
    postApiData(dataToSend);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", apiError);
    }
  }, [apiErrorCount, apiErrorCount]);
  useEffect(() => {
    if (apiResponse !== null) {
      // userType, email
      const { message } = apiResponse;
      if (message) {
        openNotification(`success`, "Success", message);
        setTimeout(() => {
          navigate("/users");
        }, 3000);
      }
    }
  }, [apiResponse]);
  return (
    <>
      {contextHolder}
      <Row className="create-package-container" gutter={[16, 16]}>
        <div className="general-form-container">
          <Typography className="general-form-title">Assign Package</Typography>

          <Form
            // className="login-form"
            name="createPackageForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              label={
                <span className="package-input-label">Select Package</span>
              }
              name="packageId"
              rules={[
                {
                  required: true,
                  message: "Please Choose Package ",
                },
              ]}
              style={{ marginBottom: "200px", color: "blue" }}
            >
              <Select
                className="package-form-select-item"
                showSearch
                placeholder="Select Validity"
                optionFilterProp="children"
                filterOption={filterOption}
                options={packageOptions}
              />
            </Form.Item>

            <Form.Item>
              <Button
                className="login-submit-button"
                type="primary"
                htmlType="submit"
              >
                Create Package
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Row>
    </>
  );
};
export default AssignPackageToUserComponent;
